export const minecraft1215 = {
  version: '1.21.5',
  title: 'Spring to Life',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/game-updates/MCV_SpringDrop_DotNet_Blog_Editorial_1280x720.jpg',
  releases: [
    {
      id: "60aT4Noc",
      version: "1.0.4",
      date: "May 14, 2025",
      changelog: "Versión estable para Minecraft 1.21.5 con todos los mods actualizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21.5",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project/files/7420943",
      isBeta: false
    },
    {
      id: "50zT3Nmb",
      version: "beta-0.2-1.0.4",
      date: "May 3, 2025",
      changelog: "Versión beta para Minecraft 1.21.5 con mejoras de rendimiento",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.2-1.0.4-1.21.5",
      curseforgeUrl: "",
      isBeta: true
    },
    {
      id: "40yT2Mla",
      version: "beta-0.1-1.0.4",
      date: "Mar 30, 2025",
      changelog: "Primera versión beta para Minecraft 1.21.5 con mods básicos",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.21.5",
      curseforgeUrl: "",
      isBeta: true
    }
  ]
};
